import UpdateCreditStatus from './update-credit-status';
import {MODAL} from 'features/modal-notch/constants';

export default {
  [MODAL.UPDATE_CREDIT_STATUS]: UpdateCreditStatus,
};
